import { Directive, HostBinding, HostListener, Input } from '@angular/core';

import { ToggleComponent } from './toggle.component';

@Directive({
    selector: '[bgToggleItem]',
    standalone: false,
})
export class ToggleItemDirective {
    @HostBinding('class.bg-toggle-active') active: boolean = false;
    @Input('bgToggleItem') value: string;

    constructor(private toggle: ToggleComponent) {
        this.toggle.addItem(this);
    }

    @HostListener('click')
    onClick() {
        this.selectItem();
        this.toggle.selectedItem(this);
    }

    selectItem() {
        this.active = true;
    }

    disableActive() {
        this.active = false;
    }
}
